import { useShowBackerInfo } from '@givebacks/api/backer';
import { centsToDollar } from 'core/Utils';
import { Card, Group, ImageMantine, Stack, Text } from 'ui';
import { svg_impact } from 'ui/Icons';

import classes from './MyCausesImpactCard.module.css';

const MyCausesImpactCard = () => {
  const { data: backer } = useShowBackerInfo();

  return (
    <Card className={classes.MyCausesImpactCard}>
      <Group justify="space-between" align="center" wrap="nowrap">
        <Stack gap={0}>
          <Text className={classes.MyCausesImpactCard__amount}>
            {centsToDollar(backer?.raised_by_backer)}
          </Text>
          <Text className={classes.MyCausesImpactCard__text}>Raised for your causes!</Text>
        </Stack>

        <ImageMantine src={svg_impact} />
      </Group>
    </Card>
  );
};

export { MyCausesImpactCard };
